import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FaqSection from '@/pages/home/components/FaqSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import TopicsSection from '@/pages/home/components/TopicsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <RankingSection />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <IndexSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}